import type { ReactNode } from 'react'
import { useState } from 'react'
import { StyleSheet, View } from 'react-native'

import { useFlowStepFrame } from '../hooks/useNestedSheetHeight'
import { useTheme } from '../theme/restyle'
import { FiatSubmissionIndicator } from './FiatSubmissionIndicator'
import { ProviderSurface } from './SurfaceSlot'

/**
 * A provider that owns the whole canvas paints nothing of ours while it boots,
 * and its own first frames are its choice (MoonPay: white, then black). The
 * modal ground with our indicator stays over it until the provider reports
 * ready, or the readiness ceiling passes.
 */
export function ScreenSurfaceCover({
  renderSurface,
}: {
  renderSurface: (onReady: () => void) => ReactNode
}) {
  const theme = useTheme()
  const { height } = useFlowStepFrame()
  const [ready, setReady] = useState(false)
  return (
    <View style={{ height, width: '100%' }}>
      <View
        style={styles.surface}
        pointerEvents={ready ? 'auto' : 'none'}
        accessibilityElementsHidden={!ready}
        importantForAccessibility={ready ? 'auto' : 'no-hide-descendants'}
      >
        <ProviderSurface
          renderSurface={renderSurface}
          onReady={() => setReady(true)}
        />
      </View>
      {ready ? null : (
        <View
          style={[
            styles.fill,
            styles.center,
            { backgroundColor: theme.background.modal },
          ]}
        >
          <FiatSubmissionIndicator />
        </View>
      )}
    </View>
  )
}

const styles = StyleSheet.create({
  surface: { flex: 1, width: '100%' },
  fill: { position: 'absolute', top: 0, right: 0, bottom: 0, left: 0 },
  center: { alignItems: 'center', justifyContent: 'center' },
})
